module.exports = __webpack_public_path__ + "img/20190523211919微信截图_20190523212234.7abb07f1.png";